export default function IconLess () {
  return (
    <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4207_28874)">
        <path
          d="M1.08709 2.8545L3.59248 5.95042C4.00845 6.46443 4.79233 6.46443 5.2083 5.95042L7.7137 2.8545C8.15364 2.31086 7.76672 1.5 7.06737 1.5L1.73341 1.5C1.03406 1.5 0.647142 2.31086 1.08709 2.8545Z"
          fill="#DE1E04"/>
      </g>
      <defs>
        <clipPath id="clip0_4207_28874">
          <rect width="8" height="8" fill="white" transform="matrix(-1 0 0 1 8.40039 0)"/>
        </clipPath>
      </defs>
    </svg>

  )
}
